import * as XLSX from "xlsx";
import { toast } from "react-hot-toast";
import { getPositionDisplay } from "./positionFormatter";

const statusMap = {
  pitch_sent: {
    label: "Pitch sent",
    className: "bg-[#F8F3ED] text-[#B97A1A]",
  },
  accepted: {
    label: "Accepted",
    className: "bg-[#EAF7F0] text-[#3BA97C]",
  },
  rejected: {
    label: "Rejected",
    className: "bg-[#FDECEF] text-[#F04B6A]",
  },
};

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const exportPitchesToExcel = async (pitches, filters, setExportingData) => {
  if (pitches.length === 0) {
    toast.error("No pitch data available to export");
    return;
  }

  setExportingData(true);
  try {
    const exportData = pitches.map((pitch) => ({
      "Agent Name": pitch.agent?.name || "N/A",
      "Player Name": pitch.player?.name || "N/A",
      "Club Name": pitch.club?.name || "N/A",
      Position:
        pitch.positionDisplay ||
        getPositionDisplay(pitch.player, pitch.position || "N/A"),
      Status: statusMap[pitch.status]?.label || pitch.status || "N/A",
      "Date Sent": formatDate(pitch.dateSent),
      "Agent Image URL": pitch.agent?.image || "N/A",
      "Player Image URL": pitch.player?.image || "N/A",
      "Club Logo URL": pitch.club?.logo || "N/A",
      "Is Player Verified": pitch.player?.isVerified ? "Yes" : "No",
      Description: pitch.description || "N/A",
      "Request ID": pitch.tender?.id || "N/A",
      "Request Title": pitch.tender?.title || "N/A",
      "Pitch ID": pitch.id || "N/A",
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);

    const colWidths = [];
    const headers = Object.keys(exportData[0]);
    headers.forEach((header, i) => {
      const maxWidth = Math.max(
        header.length,
        ...exportData.map((row) => String(row[header] || "").length)
      );
      colWidths[i] = { wch: Math.min(maxWidth + 2, 50) };
    });
    ws["!cols"] = colWidths;

    XLSX.utils.book_append_sheet(wb, ws, "Agency Pitches");

    let fileName = `Agency_Pitches_${new Date().toISOString().split("T")[0]}`;

    if (!filters.allAgentsSelected && filters.selectedAgents.length > 0) {
      fileName += `_${filters.selectedAgents.length}agents`;
    }
    if (
      !filters.allPositionsSelected &&
      filters.selectedPositions.length > 0
    ) {
      fileName += `_${filters.selectedPositions.length}positions`;
    }
    if (filters.search.trim()) {
      fileName += `_filtered`;
    }

    fileName += ".xlsx";

    XLSX.writeFile(wb, fileName);

    toast.success(
      `Successfully exported ${exportData.length} agency pitch records to Excel!`
    );
  } catch (error) {
    console.error("Error exporting agency pitches to Excel:", error);
    toast.error("Failed to export data to Excel. Please try again.");
  } finally {
    setExportingData(false);
  }
};
